type TaskDestinationParams = {
  actionUrl?: string | null;
  fileId?: number | string | null;
};

const getNormalizedFileId = (
  fileId: TaskDestinationParams["fileId"],
): number | null => {
  if (fileId == null || fileId === "") {
    return null;
  }

  const normalizedFileId = typeof fileId === "string" ? Number(fileId) : fileId;

  return Number.isSafeInteger(normalizedFileId) && normalizedFileId > 0
    ? normalizedFileId
    : null;
};

/* resolve a task destination url from explicit action url or file fallback */
export const getTaskDestinationUrl = ({
  actionUrl,
  fileId,
}: TaskDestinationParams): string | null => {
  if (actionUrl) {
    return actionUrl;
  }

  const normalizedFileId = getNormalizedFileId(fileId);

  if (!normalizedFileId) {
    return null;
  }

  return `/operations/files/${normalizedFileId}/edit/claimant-information`;
};
